import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { ErrorMessage, SuccessMessage } from "../../_UI/Components/Alerts/PathwayAlertMessages";

const Container = styled.div`
    display: grid;
    justify-items: center;
    padding: 26px 30px 0;
`;

const Message = styled.div`
    max-width: var(--pw-container-max);
    width: 100%;
`;

export const GlobalAlert = () => {
    const alert = useSelector((state) => state.alert);

    if (!alert || !alert.message) {
        return null;
    }

    return (
        <Container data-cy="global-alert">
            <Message>
                {alert.type === "general-error" && <ErrorMessage marginless>{alert.message}</ErrorMessage>}
                {alert.type === "general-success" && <SuccessMessage marginless>{alert.message}</SuccessMessage>}
            </Message>
        </Container>
    );
};

export default GlobalAlert;
